<div class="modal-header">
  <h4 class="modal-title">{{ mode === 'add' ? 'Add New SubTopic' : 'Edit SubTopic' }}</h4>
  <button type="button" class="close" (click)="onCancel()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="subTopicForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="topic_id">Select Topic *</label>
      <ng-select
        id="topic_id"
        [placeholder]="loading ? 'Loading topics...' : 'Select a topic'"
        formControlName="topic_id"
        appendTo="body"
        [loading]="loading"
        [disabled]="loading || mode == 'edit'"
        [class.is-invalid]="subTopicForm.get('topic_id')?.invalid && subTopicForm.get('topic_id')?.touched">
        <ng-option
          *ngFor="let topic of topics"
          [value]="topic.topic_id"
          [disabled]="mode == 'edit'">
          {{ topic.topic_name }}
        </ng-option>
      </ng-select>
      <div class="invalid-feedback" *ngIf="getFieldError('topic_id')">
        {{ getFieldError('topic_id') }}
      </div>
      <div *ngIf="topics.length === 0 && !loading" class="text-muted mt-2">
        No topics available. Please add topics first.
      </div>
      <div *ngIf="loading" class="text-muted mt-2">
        <i class="fa fa-spinner fa-spin"></i> Loading topics...
      </div>
    </div>

    <div class="mb-3">
      <label for="sub_topic_name">SubTopic Name *</label>
      <input
        type="text"
        id="sub_topic_name"
        class="form-control"
        formControlName="sub_topic_name"
        placeholder="Enter subtopic name"
        [class.is-invalid]="subTopicForm.get('sub_topic_name')?.invalid && subTopicForm.get('sub_topic_name')?.touched">
      <div class="invalid-feedback" *ngIf="getFieldError('sub_topic_name')">
        {{ getFieldError('sub_topic_name') }}
      </div>
    </div>

    <div class="mb-3">
      <label for="secondary_prompt">Secondary Prompt *</label>
      <textarea
        id="secondary_prompt"
        class="form-control"
        formControlName="secondary_prompt"
        placeholder="Enter secondary prompt"
        rows="4"
        [class.is-invalid]="subTopicForm.get('secondary_prompt')?.invalid && subTopicForm.get('secondary_prompt')?.touched">
      </textarea>
      <div class="invalid-feedback" *ngIf="getFieldError('secondary_prompt')">
        {{ getFieldError('secondary_prompt') }}
      </div>
    </div>
    <div class="mb-3" *ngIf="mode === 'edit'">
      <div class="form-check">
        <input
          type="checkbox"
          id="status"
          class="form-check-input"
          formControlName="status">
        <label class="form-check-label" for="status">
          Active
        </label>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="onCancel()"
    [disabled]="loading">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    [disabled]="loading || subTopicForm.invalid">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
    {{ mode === 'add' ? 'Add SubTopic' : 'Update SubTopic' }}
  </button>
</div>
